import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "TextTracking"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.9675 14.4675L17.91 15.5325L19.6275 17.25H4.3725L6.09 15.5325L5.0325 14.4675L1.5 18L5.0325 21.5325L6.09 20.4675L4.3725 18.75H19.6275L17.91 20.4675L18.9675 21.5325L22.5 18L18.9675 14.4675ZM19.5 12.75H21L17.25 2.25H15.75L12 12.75H13.5L14.25 10.5H18.75L19.5 12.75ZM14.7525 9L16.5 3.75L18.2475 9H14.7525ZM10.5 2.25L7.5 11.25L4.5 2.25H3L6.75 12.75H8.25L12 2.25H10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/TextTracking.vue"]]);
